module.exports = __webpack_public_path__ + "53.1fc49269b43adb99fad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/53.jpg
// module id = ./src/assets/images/wedding/andy_jeska/53.jpg
// module chunks = main